import {Grid, MenuItem, Select, styled, TextField, Typography} from "@mui/material";
import React from "react";
import {Controller, useFormContext} from "react-hook-form";
import MWCaption from "../../components/MWCaption";

import PersonIcon from "@mui/icons-material/Person";
import {Box} from "@mui/system";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {useRecoilValue} from "recoil";
import {useDepartmentList} from "../../hooks/useDepartmentList";
import {EQUser} from "../../models/serverModels/EQUser";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {error} from "console";
import ko from "date-fns/locale/ko";

const CategoryFormContainer = styled(Grid)(({theme}) => ({
  justifyContent: "center",
  alignItems: "center",
  marginTop: "16px",

  backgroundColor: "#fff",
  "& p": {
    marginTop: "8px",
  },
}));
const CategoryFormContent = styled(Grid)(({theme}) => ({
  display: "flex",
  flexFlow: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  margin: "32px 0",

  padding: "24px",
  border: `1px solid ${theme.palette.background.paper}`,
  borderRadius: "16px",
  boxShadow:
    "rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem",

  "& label": {
    fontWeight: 600,
    paddingRight: "8px",
  },
}));

const DocumentList = styled(Box)(({theme}) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  "& label": {
    flexBasis: "30%",
  },
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));
const BoardManagerForm = () => {
  const methods = useFormContext<EQUser>();
  const {control} = methods;
  return (
    <React.Fragment>
      <MWCaption title="게시판 담당자 관리" icon={<PersonIcon />} />
      <CategoryFormContainer container>
        <CategoryFormContent
          item
          xs={12}
          sm={12}
          md={6}
          xl={4}
          sx={{padding: {xs: "16px 4px", sm: "16px 8px", md: "24px"}}}
        >
          <Controller
            name="name"
            control={control}
            render={({field, fieldState: {error}}) => (
              <DocumentList>
                <label htmlFor="name">이름 : </label>
                <TextField
                  {...field}
                  id="name"
                  size="small"
                  placeholder="이름"
                  margin="dense"
                  helperText={error?.message}
                  autoFocus
                  sx={{width: "100%"}}
                />
              </DocumentList>
            )}
          />

          <Controller
            name="email"
            control={control}
            render={({field, fieldState: {error}}) => (
              <DocumentList>
                <label htmlFor="email">이메일 : </label>
                <TextField
                  {...field}
                  id="email"
                  size="small"
                  placeholder="이메일"
                  margin="dense"
                  helperText={error?.message}
                  sx={{width: "100%", color: "#000"}}
                />
              </DocumentList>
            )}
          />
          <Controller
            name="loginID"
            control={control}
            render={({field, fieldState: {error}}) => (
              <DocumentList>
                <label htmlFor="loginID">아이디 : </label>
                <TextField
                  {...field}
                  id="loginID"
                  size="small"
                  placeholder="아이디"
                  margin="dense"
                  helperText={error?.message}
                  sx={{width: "100%", color: "#000"}}
                />
              </DocumentList>
            )}
          />
          <Controller
            name="loginPW"
            control={control}
            render={({field, fieldState: {error}}) => (
              <DocumentList>
                <label htmlFor="loginPW">비밀번호 : </label>
                <TextField
                  {...field}
                  id="loginPW"
                  size="small"
                  placeholder="비밀번호"
                  margin="dense"
                  helperText={error?.message}
                  sx={{width: "100%", color: "#000"}}
                />
              </DocumentList>
            )}
          />
          <Controller
            name="registerDate"
            control={control}
            render={({field, ...props}) => (
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ko}>
                <DocumentList>
                  <label htmlFor="registerDate">등록일 : </label>
                  <DatePicker
                    inputFormat={"yyyy년 MM월 dd일"}
                    value={field.value}
                    onChange={(date) => {
                      if (!date) return field.onChange(null);

                      const d = new Date(date); // string 가능 → 자동 파싱됨

                      const fixed = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 9, 0, 0);

                      field.onChange(fixed);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        id="registerDate"
                        size="small"
                        margin="dense"
                        sx={{width: "100%"}}
                      />
                    )}
                  />
                </DocumentList>
              </LocalizationProvider>
            )}
          />
          <Controller
            name="expireDate"
            control={control}
            render={({field, fieldState: {error}}) => (
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DocumentList>
                  <label htmlFor="expireDate">만료일 : </label>
                  <DatePicker
                    inputFormat={"yyyy년 MM월 dd일"}
                    value={field.value}
                    onChange={(date) => {
                      if (!date) return field.onChange(null);

                      const d = new Date(date); // string 가능 → 자동 파싱됨

                      const fixed = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 9, 0, 0);

                      field.onChange(fixed);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        id="expireDate"
                        size="small"
                        margin="dense"
                        helperText={error?.message}
                        sx={{width: "100%"}}
                      />
                    )}
                  />
                </DocumentList>
              </LocalizationProvider>
            )}
          />
        </CategoryFormContent>
      </CategoryFormContainer>
    </React.Fragment>
  );
};

export default BoardManagerForm;
